import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import Loader from 'Components/Loader';

const DownloadButton = styled(Button)`
  background: #fff !important;
  margin-right: 16px !important;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  background-color: rgb(234, 234, 234);
  padding: 20px;
`;
const FieldError = styled.div`
  font-size: 0.75rem;
  color: red;
  font-weight: 300;
`;

const styles = theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(255, 202, 40)',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'grey',
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(234, 234, 234)',
  },
}))(MuiDialogActions);

function ValidateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return false;
  }
  return true;
}

const CustomizedDialogs = props => {
  return (
    <Dialog
      onClose={props.closeLogsDialog}
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <DialogTitle id="customized-dialog-title" onClose={props.closeLogsDialog}>
        Download Logs
      </DialogTitle>
      <DialogContent>
        Email:
        <Input
          fullWidth
          label="Message"
          variant="outlined"
          onChange={props.setSendOnMail}
          value={props.sendOnMail}
          inputProps={{
            'aria-label': 'Description',
          }}
        />
        {ValidateEmail(props.sendOnMail) ? (
          <FieldError>Email must be in valid format</FieldError>
        ) : null}
      </DialogContent>
      <DialogActions>
        <DownloadButton
          disabled={ValidateEmail(props.sendOnMail)}
          autoFocus
          onClick={props.downloadLogs}
          variant="contained"
          className="t-weight-b criteria-button"
        >
          <React.Fragment>
            <Loader isLoading={props.sending} size={32} />
            <p
              style={{
                visibility: props.sending ? 'hidden' : 'visible',
              }}
            >
              Request
            </p>
          </React.Fragment>
        </DownloadButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomizedDialogs;
